import request from '@/utils/request'

const url = 'admin/demo.view_demo'
/**
 * 代码生成表单类型演示接口API
 */

const api = {
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },

  /**
   * 添加ViewDemo
   * @returns
   */
  Create(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
   * 编辑ViewDemo
   * @returns
   */
  Update(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
   * 详情ViewDemo
   * @returns
   */
  Detail(id) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      params: { id }
    })
  },

  /**
   * 删除ViewDemo
   * @returns
   */
  Delete(data) {
    return request({
      url: `${url}/destroy`,
      method: 'post',
      data
    })
  },

  /**
   * 更改ViewDemo数据
   * @returns
   */
  ChangeStatus(data) {
    return request({
      url: `${url}/changeStatus`,
      method: 'post',
      data
    })
  },

  /**
   * 修改ViewDemo数值数据，自增自减
   * @returns
   */
  NumberOperation(data) {
    return request({
      url: `${url}/numberOperation`,
      method: 'post',
      data
    })
  },

  /**
   * ViewDemo导入
   * @returns
   */
  Import(data) {
    return request({
      url: `${url}/import`,
      method: 'post',
      data
    })
  },

  /**
   * ViewDemo下载模板
   * @returns
   */
  downloadTemplate() {
    return request({
      url: `${url}/downloadTemplate`,
      method: 'post',
      responseType: 'blob'
    })
  },

  /**
   * 导出ViewDemo数据
   * @returns
   */
  Export(data) {
    return request({
      url: `${url}/export`,
      method: 'post',
      data
    })
  }

}

export default api
